import { VerticalSpace } from '@framework/ui/components/space/VerticalSpace.tsx';
import { Alert } from 'antd';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { BaseLayoutColSpanInput } from '../../common/BaseLayoutColSpanInput.tsx';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps.ts';
import { type ICompanyWidget } from './ICompanyWidget.tsx';

export interface ICompanyWidgetConfigComponentProps
  extends IWidgetComponentProps<ICompanyWidget> {}

export function CompanyWidgetConfigComponent(
  props: ICompanyWidgetConfigComponentProps,
) {
  const options = getWidgetProps(props);
  return (
    <>
      <Alert
        type="info"
        message={
          <>
            Configurando un&apos;azienda in questo elemento impostando i campi
            con i relativi &quot;Attributo del titolare della richiesta&quot;,
            tutti i titolari della richiesta presenti all&apos;interno di questo
            elemento saranno collegati all&apos;azienda configurata come legali
            rappresentati.
          </>
        }
      />
      <VerticalSpace />
      <BaseLayoutColSpanInput isTableColumn={options.isTableColumn} />
    </>
  );
}
